<template>
  <ui-select
    :value="selectValue"
    :options="options"
    @change="onChange"
  />
</template>

<script>
import categorySortMixin from './category-sort-mixin';

export default {
  mixins: [categorySortMixin],
}
</script>
